import React from "react";
import { ClientApartment } from "../../../utils/api/apartmentRentalsAPI";

interface FormData {
  adults: number;
  children: number;
}

interface Props {
  apt: ClientApartment;
  formData: FormData;
  setAdults: (n: number) => void;
  setChildren: (n: number) => void;
  lang: string;
  t: (key: any) => any;
}

const Stepper: React.FC<{
  label: string;
  sub?: string;
  value: number;
  min: number;
  max: number;
  onChange: (n: number) => void;
}> = ({ label, sub, value, min, max, onChange }) => (
  <div className="pab-guest-row">
    <div className="pab-guest-row__info">
      <div className="pab-guest-row__label">{label}</div>
      {sub && <div className="pab-guest-row__sub">{sub}</div>}
    </div>
    <div className="pab-stepper">
      <button
        type="button"
        className="pab-stepper__btn"
        disabled={value <= min}
        onClick={() => onChange(Math.max(min, value - 1))}
        aria-label={`${label} minus`}
      >
        −
      </button>
      <span className="pab-stepper__value">{value}</span>
      <button
        type="button"
        className="pab-stepper__btn"
        disabled={value >= max}
        onClick={() => onChange(Math.min(max, value + 1))}
        aria-label={`${label} plus`}
      >
        +
      </button>
    </div>
  </div>
);

const StepGuests: React.FC<Props> = ({
  apt, formData, setAdults, setChildren, lang, t,
}) => {
  const totalGuests = formData.adults + formData.children;
  const maxChildren = Math.max(0, apt.capacity - formData.adults);

  return (
    <div className="pab-step">
      <h2 className="pab-step__title">{lang === "en" ? "How many guests?" : "Koliko gostiju dolazi?"}</h2>
      <div className="pab-step__subtitle">
        {lang === "en" ? `Up to ${apt.capacity} guests` : `Do ${apt.capacity} gosta`}
      </div>

      <div className="pab-guest-card">
        <Stepper
          label={t("adults")}
          sub={lang === "en" ? "13+ years" : "13+ godina"}
          value={formData.adults}
          min={1}
          max={apt.capacity}
          onChange={setAdults}
        />
        <div className="pab-guest-row__divider" />
        <Stepper
          label={t("children")}
          sub={lang === "en" ? "0–12 years" : "0–12 godina"}
          value={formData.children}
          min={0}
          max={maxChildren}
          onChange={setChildren}
        />
      </div>

      <div className="pab-guest-total">
        {totalGuests} {lang === "en" ? (totalGuests === 1 ? "guest" : "guests") : (totalGuests === 1 ? "gost" : "gosta")}
      </div>
    </div>
  );
};

export default StepGuests;
